(function () {
  if (window.__AW_FREEGIFT_REFRESH__) return;
  window.__AW_FREEGIFT_REFRESH__ = true;

  if (!/^\/cart\/?$/.test(location.pathname)) return;

  function getRoot() {
    return document.querySelector("[data-aw-freegift-root]");
  }

  function getConfig(root) {
    var el = root.querySelector("[data-aw-freegift-config]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatYenFromCents(cents) {
    var yen = Math.max(0, Math.floor((Number(cents) || 0) / 100));
    return yen.toLocaleString("ja-JP");
  }

  function renderMessage(root, cfg, remainingCents) {
    var msgBox = root.querySelector("[data-aw-freegift-msg]");
    if (!msgBox) return;


    var p = msgBox.querySelector("p");
    if (!p) {
      p = document.createElement("p");
      msgBox.appendChild(p);
    }

    var qualified = remainingCents <= 0;
    var template = qualified ? cfg.msgQualified : cfg.msgRemaining;

    var amountStr = formatYenFromCents(remainingCents);
    var text = String(template || "");
    text = text.replace(/\{amount\}/g, amountStr);

    p.innerHTML = escapeHtml(text).replace(/\n/g, "<br>");
  }

  var inflight = false;
  var queued = false;

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function calcEligibleSum(cart, cfg) {
    var items = cart && cart.items ? cart.items : [];
    var sum = 0;

    var useAll = !!cfg.useAll;
    var excludeVid = String(cfg.excludeVariantId || "");

    if (useAll) {
      items.forEach(function (it) {
        if (excludeVid && String(it.id) === excludeVid) return;
        sum += Number(it.final_line_price || it.line_price || 0);
      });
      return sum;
    }

    var keys = Array.isArray(cfg.eligibleKeys) ? cfg.eligibleKeys : [];
    var keySet = new Set(keys.map(String));

    items.forEach(function (it) {
      if (!keySet.has(String(it.key))) return;
      if (excludeVid && String(it.id) === excludeVid) return;
      sum += Number(it.final_line_price || it.line_price || 0);
    });

    return sum;
  }

  function refresh() {
    var root = getRoot();
    if (!root) return;

    var cfg = getConfig(root);
    if (!cfg) return;

    if (inflight) {
      queued = true;
      return;
    }
    inflight = true;

    fetchCart()
      .then(function (cart) {
        var sum = calcEligibleSum(cart, cfg);
        var remaining = Number(cfg.thresholdCents || 0) - sum;
        renderMessage(root, cfg, remaining);
      })
      .catch(function () {})
      .then(function () {
        inflight = false;
        if (queued) {
          queued = false;
          setTimeout(refresh, 0);
        }
      });
  }

  function isCartMutationUrl(url) {
    return /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/.test(String(url || ""));
  }

  if (window.jQuery && window.jQuery(document).ajaxComplete) {
    window.jQuery(document).ajaxComplete(function (_evt, _xhr, settings) {
      if (settings && isCartMutationUrl(settings.url)) {
        setTimeout(refresh, 0);
      }
    });
  }

  if (window.fetch) {
    var _fetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url =
        typeof input === "string"
          ? input
          : input && input.url
            ? input.url
            : "";
      return _fetch(input, init).then(function (res) {
        if (isCartMutationUrl(url)) setTimeout(refresh, 0);
        return res;
      });
    };
  }

  if (window.XMLHttpRequest) {
    var XHR = window.XMLHttpRequest;
    var _open = XHR.prototype.open;
    var _send = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this.__aw_url = url;
      return _open.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      var xhr = this;
      xhr.addEventListener("loadend", function () {
        if (isCartMutationUrl(xhr.__aw_url)) setTimeout(refresh, 0);
      });
      return _send.apply(this, arguments);
    };
  }

  document.addEventListener("DOMContentLoaded", function () {
    refresh();
  });
})();